import React, { useState, useEffect } from 'react';
import Button from './../../../../components/button/Button';
import Input from '../../../../components/input/Input';
import Editor from '../../../../components/editor/Editor';
import axios from 'axios';
import ApiUrl from '../../../../services/ApiUrl';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../../../components/page-title/PageTitle';
import readTextNvda from './../../../../services/readTextNvda';

const Clinic = (props) => {
    let dispatch = useDispatch();
    let [ load, setLoad ] = useState(false)
    let [ blockedBtn, setBlockedBtn ] = useState(false);
    let [ title, setTitle ] = useState('');
    let [ editor, setEditor ] = useState('');
    let [ forceValidate, setForceValidate ] = useState(false);
    let pageID = typeof window !== "undefined" && (window.location.pathname).split("/");pageID = pageID[pageID.length -1]

    useEffect(() => {
        if(!load) {
            getClinic();
            setLoad(true);
        }
    }, [load])

    const getClinic = () => {
        axios({
            method: 'get',
            url: `${ApiUrl()}/getClinicByID?clinicID=${pageID}`,
            headers: { Authorization: `Bearer ${ localStorage.getItem('token') }` }
        }).then(response => {
            let res = JSON.parse(response.request.response);
            setTitle(res.title);
            setEditor(res.editor);
        })
    }

    const validate = async() => {
        await setForceValidate(true);
        await wait(100);
        await setForceValidate(false);
        let errors = await checkErrors();
        if(!errors) {
            save();
        }
    }

    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll(`.clinic-container .error`);
        if( elements.length > 0 ) {
            readTextNvda("clinic");
            let topElement = elements[0].getBoundingClientRect().top;
            let windowScroll = window.scrollY;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: windowScroll + topElement
              });
            result = true;
        } else {
            result = false;
        }
        return result;
    }

    const save = () => {
        if(!blockedBtn) {
            setBlockedBtn(true);
            axios({
                method: 'post',
                url: `${ApiUrl()}/saveClinics`,
                data: {
                    clinicID: pageID,
                    token: localStorage.getItem('token'),
                    title: title,
                    editor: editor,
                    userID: localStorage.getItem('userId'),
                    edit: true,
                }
            }).then(response => {
                let res = JSON.parse(response.request.response);
                if(res.status = "success") {
                    setBlockedBtn(false);
                    dispatch({ type: 'NOTIFICATION_ALERT_TEXT', value: `<p>Poradnia została zaaktualizowana</p>` }) 
                }else{
                    setBlockedBtn(false);
                    dispatch({ type: 'NOTIFICATION_ALERT_TEXT', value: `<p>Coś poszło nie tak, prosimy spróbować później</p>` }) 
                }
            })
        }
    }

    return (
        <div className="container clinic-container">
            <div className="wrapper">
                <PageTitle title="Edytuj poradnie:" />
                <div className="form">
                    <div className="input-row">
                        <Input  name="title"
                            required={ true }
                            label="Tytuł"
                            type="text" 
                            value={ title }
                            disabled={ false } 
                            setFunction={ (val) => setTitle(val) } 
                            forceValidate={ forceValidate }
                            class="btn-primary btn-simple" />
                    </div>
                    <div className="input-section">
                        <Editor label={"Treść"} required={true} forceValidate={ forceValidate } setFunction={ val => setEditor(val) } value={editor} />
                    </div>
                    <div className="save-btn">
                        <Button title="Zapisz" class="btn-secondary" setFunction={() => validate()} /> 
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Clinic;
